var mapData = []
var max = -Infinity;
var min = Infinity;
mapData.forEach(function(itemOpt) {
    if (itemOpt.value > max) {
        max = itemOpt.value;
    }
    if (itemOpt.value < min) {
        min = itemOpt.value;
    }
});
export default {
    backgroundColor: 'transparent',
    title: {
        text: '',
        left: 'center',
        top: 'bottom',
        textStyle: {
            color: 'gray'
        }
    },
    tooltip: {
        show: true,
        trigger: 'item',
        showDelay: 100,
        padding: [5,8,5,8],
        borderWidth: 2,
        position: function (point, params, dom, rect, size) {
        if ( params.seriesType !== 'map') {
        return [point[0] + 15  , point[1] - (size.contentSize[1] + 15 )]
        } else {
        return 
        }
       },
        borderColor: 'rgba(255,255,255,0.2)',
        transitionDuration: 0.2,
        formatter: function(params) {
            if ( typeof(params) == 'object') {
            if (params.seriesName === 'Nearest' &&  params.data && params.data.value && params.data.value[3] === 0 ) return;
            var meta =  params.meta ? params.meta : params.data && params.data.meta ? params.data.meta : false
            var locality = params.locality ? params.locality : params.data && params.data.locality ? params.data.locality.meta : false
            var label = params.name.replace(/_/g, " ").split('@')[0]
            var value = params.data && params.data.value[3] ? params.data.value[3] : params.data &&  params.data.value[2] ? params.data.value[2] : params.value
            if (meta) {
                if ((meta.age !== null && typeof(meta.age) !== 'undefined') || (meta.origin !== null && typeof(meta.origin) !== 'undefined')) {
                    var age = meta.age === null || typeof(meta.age) === 'undefined' ? '' : (meta.age - 100000) < 0 ? -1 * (meta.age - 100000) + ' BCE' : meta.age - 100000 + ' CE';
                    var origin = meta.origin === null | typeof(meta.origin) === 'undefined' ? '' : meta.origin
                    let component = params.data && params.data.parent ? unescape(params.data.parent).replace(/_/g, ' ') : '';
                    if (component !== '') {
                        return `&nbsp;<b>${component}</b><br>&nbsp;${label} ${age} (${origin})<br>&nbsp;<b>${value} %</b>`;
                    } else {
                    if ( value ) {
                        return `&nbsp;<b>${origin}</b><br>&nbsp;${label} ${age}&nbsp; <br>&nbsp;<b>${value} %</b>`;
                        }
                    }
                } else {
                    if ( value ) {
                    return `&nbsp;${label}&nbsp;<br>&nbsp;<b>${value} %</b>`;
                    }
                }
            } else if (locality) {
                let txt = locality.state ? `${locality.city},<br>&nbsp;${locality.state}<br>&nbsp;${locality.country}` : `${locality.city}<br>&nbsp;${locality.country}`
                return `&nbsp;<b>${label}</b>&nbsp;<br>&nbsp;<span style="color:silver">${txt}</span>`;
            } else {
                    if ( value ) {
                return `&nbsp;${label}&nbsp;<br>&nbsp;<b>${value} %</b>`;
                }
            }
            }
        }
    },
    visualMap: {
        show: false,
        min: 1,
        max: 100,
        inRange: {
            symbolSize: [4, 60],
        }
    },
    visualaMap: {
        show: false,
        type: 'continuous',
        dimension: 3,
        min: 1,
        max: 100,
        inRange: {
            //color: ['lightskyblue', 'yellow', 'orangered']
                //areaColor: '#323c48',
            color: ['#2c526f','#fdae61', '#f46d43', '#d73027', '#a50026']
        },
        calculable: true
    },
    roamController: {
        show: false,
        mapTypeControl: {
            world: true
        }
    },
    geo: {
        type: 'map',
        show: true,
        map: 'world',
        roam: true,
        zoom: 1.25,
        label: {
						show: false,
						color: 'white',
            emphasis: {
                showDelay: 0.3,
                transitionDuration: 0.2,
                show: true,
                color: 'white',
                textShadowBlur: 20,
                textShadowOffsetX: 0,
                textShadowOffsetY: 0,
                textShadowColor: 'rgba(0, 0, 0, 0.7)'
            }
        },
        itemStyle: {
            normal: {
                areaColor: 'gray',
                areaColor: '#323c48',
                borderColor: '#fff',
                borderColor: 'silver'
            },
            emphasis: {
                areaColor: '#2a333d',
                areaColor: 'gray',
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: 'rgba(0, 0, 0, 0.2)'
            }
        }
    },
    series: [{
            name: 'Ancestry',
            type: 'scatter',
            //type: 'effectScatter',
            visualMap: false,
            coordinateSystem: 'geo',
            z: 1,
            data: mapData.map(function(itemOpt) {
                return {
                    name: itemOpt.name,
                    visualMap: false,
                    //symbolSize: itemOpt.custom ? 10 : itemOpt.value,
                    symbolSize: 0,
                    value: [
                        itemOpt.value === 0 ? undefined : itemOpt.longitude,
                        itemOpt.value === 0 ? undefined : itemOpt.latitude,
                        itemOpt.custom ? 10 : itemOpt.value,
                    ],
                    label: {
                        emphasis: {
                            position: 'right',
                            show: false
                        }
                    },
                    itemStyle: {
                        normala: {
                            color: itemOpt.color,
                            borderColor: 'white',
                            borderWidth: 3,
                            shadowBlur: 10,
                            shadowColor: '#333'
                        }
                    }
                };
            }),
            showEffectOn: 'render',
            rippleEffect: {
                brushType: 'fill'
            },
            hoverAnimation: true
        },
        {
            name: 'User',
            visualMap: false,
            type: 'effectScatter',
            //type: 'scatter',
            z: 2,
            coordinateSystem: 'geo',
            data: mapData.map(function(itemOpt) {
                return {
                    name: itemOpt.name,
                    symbolSize: itemOpt.custom ? 10 : itemOpt.value,
                    value: [
                        itemOpt.value === 0 ? undefined : itemOpt.longitude,
                        itemOpt.value === 0 ? undefined : itemOpt.latitude,
                        itemOpt.custom ? 10 : itemOpt.value,
                    ],
                    label: {
                        emphasis: {
                            position: 'right',
                            show: false
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: itemOpt.color,
                            color: 'white',
                            shadowBlur: 10,
                            shadowColor: '#333'
                        }
                    }
                };
            }),
            showEffectOn: 'render',

            rippleEffect: {
                brushType: 'stroke',
                period: 3,
                color: 'white',
                scale: 3,
            },
            hoverAnimation: false
        },
        {
            name: 'Nearest',
            type: 'map',
            geoIndex: 0,
            value: 0,
            visualMap: false,
            data: []
        }
    ]
};
